import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Observable } from "rxjs";

@Component({
  selector: "kpi-booked-sales-meeting-detail",
  templateUrl: "./kpi-booked-sales-meeting-detail.component.html",
  styleUrls: ["./kpi-booked-sales-meeting-detail.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiBookedSalesMeetingDetailComponent {
  @Input() resources$: Observable<any>;
}
